import angular from 'angular'

import home from './pages/home/home'
import styles from './styles/main.scss'
import ngParallax from 'ng-parallax'

angular
  .module('app', [
    'app.components',
    'app.home',
    'ngParallax'
  ])
  .config(($urlRouterProvider) => {
    $urlRouterProvider.otherwise('/home')
  })




// WEBPACK FOOTER //
// ./src/app/app.js